<template>
    <section>
        <p>
            <span style="padding: 10px 10px 40px 10px; font-weight: 700; color: black">Showing {{ clinicsItems.length }} healthcare providers</span>
        </p>
        <v-row v-if="!loading.clinic && clinicsItems && clinicsItems.length > 0">
            <v-col
                v-for="(clinicItem, index) in clinicsItems"
                :key="index"
                cols="12"
                sm="6"
                md="4"
                class="d-flex"
            >
                <v-card 
                    class="hosp-item-clinic-partner d-flex flex-column pa-4 w-100" 
                    @click="displayDoctorsFromClinic(clinicItem)"
                >
                    <h3 class="text-h6 font-weight-bold mb-3">
                        {{ clinicItem.hosp_name }}
                    </h3>

                    <!-- Address Section -->
                    <div class="d-flex align-start mb-4">
                        <v-icon class="mr-2">
                            {{ mdiHospitalMarker }}
                        </v-icon>
                        <span>
                            {{ clinicItem.hosp_address }}
                        </span>
                    </div>

                    <!-- Location Footer -->
                    <div class="mt-auto pt-2">
                        <div class="d-flex align-center mb-1">
                            <v-icon class="mr-2">
                                {{ mdiMapMarkerRadius }}
                            </v-icon>
                            <span>{{ clinicItem.city_name }}</span>
                        </div>

                        <div class="d-flex align-center">
                            <v-icon class="mr-2">
                                {{ mdiMapMarker }}
                            </v-icon>
                            <span>
                                {{ clinicItem.hosp_region }} &bull; {{ clinicItem.city_province }}
                            </span>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else-if="!loading.clinic" style="padding: 25px;">
            <v-col class="text-center" style="border-radius: 12px; border: 2px dashed #4EB352;">
                <v-icon style="font-size: 100px;" color="success">
                    {{ mdiMapSearchOutline }}
                </v-icon>
                <h1 style="margin: 30px 0; color: #4CAF50; font-size: 23px;">
                    No Clinics Found
                </h1>
                <p>We couldn't find any clinics matching your search criteria. Try adjusting your filters.</p>
            </v-col>
        </v-row>
        <v-row v-else style="height: 50px;">
            <v-progress-linear
                color="success"
                reverse
                height="25"
                indeterminate
            />
        </v-row>
        <v-btn
            v-if="showGoToTop"
            color="success"
            fab
            large
            style="position: fixed; bottom: 18px; right: 10%; z-index: 20;"
            @click="handleGoToTop"
        >
            <v-icon>{{ mdiMenuUp }}</v-icon>
        </v-btn>
        <ClinicTableDialog
            :show="displayClinicTable"
            :clinic="clinic"
            :selected-hosp="selectedHosp"
            :loading="loading"
            @closeDialog="displayClinicTable = false"
        />
    </section>
</template>

<script>
import { mdiHospitalMarker, mdiMapMarker, mdiMapMarkerRadius, mdiMapSearchOutline, mdiMenuUp } from '@mdi/js'
import ClinicTableDialog from '../dialog_tables/ClinicTable_dialog.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
    components: {
        ClinicTableDialog
    },
    props: ['loading', 'search'],
    data() {
        return {
            mdiHospitalMarker, mdiMapMarker, mdiMapMarkerRadius, mdiMapSearchOutline, mdiMenuUp,
            clinicsItems: [],
            showGoToTop: false,
            goToOptions: {
                duration: 500,
                offset: 700,
                easing: 'easeInOutCubic'
            },
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 2
            },
            selectedHosp: null,
            displayClinicTable: false,
            clinic: null,
            headers: [
                { value: 'hosp_name', text: 'Clinic', sortable: true, align: 'left' },
                { value: 'hosp_address', text: 'Address', sortable: true, align: 'center' },
                { value: 'city_name', text: 'City', sortable: true, align: 'center' },
                { value: 'city_region', text: 'Region', sortable: true, align: 'center' },
                { value: 'city_province', text: 'Province', sortable: true, align: 'center' }
            ]
        }
    },
    computed: {
        ...mapGetters(['getRegions', 'getProvinces', 'getCities', 'getHospClin', 'getHospClinDialog'])
    },
    watch: {
        getHospClinDialog() {

        },
        getHospClin(newVal) {
            this.loading.clinic = false
            if (this.search.value) {
                this.clinicsItems = this.getHospClin.filter( item => item.hosp_name.toLowerCase().includes(this.search.value.toLowerCase()) )
            } else {
                this.clinicsItems = newVal
            }
        },
        'search.value'(newVal) {
            if (newVal) {
                this.clinicsItems = this.getHospClin.filter( item => item.hosp_name.toLowerCase().includes(newVal.toLowerCase()) )
            } else {
                this.clinicsItems = this.getHospClin
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.checkScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.checkScroll)
    },
    methods: {
        ...mapActions(['regions', 'provinces', 'cities', 'hospClin', 'hospClinDialog', 'getCsrfToken']),
        async displayDoctorsFromClinic(clinic) {
            this.loading.tempClinic = true
            this.selectedHosp = clinic
            this.clinic = clinic.hosp_name
            await this.hospClinDialog({
                PTYPE: 'C',
                HOSP_MSU: clinic.hosp_msu_code,
                SPEC: ''
            })
            this.displayClinicTable = !this.displayClinicTable
        },
        checkScroll() {
            this.showGoToTop = window.scrollY > 1000 // adjust threshold as needed
        },
        handleGoToTop() {
            let el = document.querySelector('.healthcareClinicClass')
            if (el) this.$vuetify.goTo(el, this.goToOptions)
        }
    }
}
</script>

<style>
.hosp-item-clinic-partner h3 {
  color: #1f2937;
  line-height: 1.3;
}
.hosp-item-clinic-partner {
  padding: 24px !important;
  margin-bottom: 16px;
  min-height: 220px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: 2px solid transparent;
}
  .hosp-item-clinic-partner .v-chip {
    font-weight: 600 !important; /* Less bold */
    font-size: 12px !important;
    margin-top: 16px;
    align-self: flex-start; /* Better alignment */
  }
.hosp-item-clinic-partner:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(78, 179, 82, 0.15);
  border-color: #4EB352;
}
  .hosp-item-clinic-partner ul {
    display: grid;
    gap: 12px;
    margin-bottom: 8px;
  }
    .hosp-item-clinic-partner ul li {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      width: 100%;
    }
      .hosp-item-clinic-partner ul li i {
        color: #4EB352 !important;
        font-size: 18px !important;
        margin-top: 2px;
        flex-shrink: 0;
      }
        .hosp-item-clinic-partner ul li span {
          flex: 1;
          font-size: 14px;
          color: #6b7280;
          line-height: 1.4;
        }
</style>
